export interface Config {
  colors: string[];
  letters: string[];
  minRadius: number;
  maxRadius: number;
  ballCount: number;
  maxBallCount: number;
  repelStrength: number;
  repelRadius: number;
  bounce: number;
  friction: number;
  density: number;
  gravityScale: number;
  dropDelay: number;
  startHeight: number;
  fillArea: number;
  frictionAir: number;
  angularDamping: number;
  maxVelocity: number;
}

const CONFIG: Config = {
  colors: ['#FAE800', '#FE96B5', '#FF8114', '#0066EE', '#00B852'],
  letters: ['H', 'A', 'P', 'Y', 'S', 'O', 'C', 'K', 'S'],
  minRadius: 60,
  maxRadius: 80,
  ballCount: 5,
  maxBallCount: 10,
  repelStrength: 0.002,
  repelRadius: 75,
  bounce: 0.95,
  friction: 0.001,
  density: 0.001,
  gravityScale: 0.2,
  dropDelay: 100,
  startHeight: -50,
  fillArea: 0.20,
  frictionAir: 0.005,
  angularDamping: 0.1,
  maxVelocity: 5
}

export default CONFIG
